<template>
  <!-- 提现管理 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="提现用户:" prop="customerName">
                <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
              </el-form-item>
              <el-form-item label="提现状态:" prop="drawalStatus">
                <el-select  v-model="searchFrom.drawalStatus"   placeholder="请选择">
                  <el-option label="已提现" value="0"></el-option>
                  <el-option label="提现中" value="1"></el-option>
                  <el-option label="提现失败" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否自动提现:" prop="isAutoWithdraw">
                <el-select  v-model="searchFrom.isAutoWithdraw"   placeholder="请选择">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="付款时间:" prop="updateTime">
                <el-date-picker
                  v-model="searchFrom.updateTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item> -->
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item btnCode="00JP00HB001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div>
            <el-button type="primary"  size="mini"   @click="tixianFn(scope.row)" btnCode="00JP00HB002" v-if="btnFlg[1]&&scope.row.drawalStatus==1" >提现</el-button>
            <!-- <el-button type="text" size="mini"  btnCode="00JP00HB003" v-if="btnFlg[2]&&scope.row.drawalStatus==0" @click="pingZheng(scope.row)">凭证</el-button> -->
            <span v-if="scope.row.drawalStatus==2||scope.row.drawalStatus==0">-</span>
            </div>
          </template>
        </el-table-column>
          <el-table-column property="accountType" width="120"   label="提现客户类型">
            <template scope="scope">{{[ "货主", "司机","车队","车队长"][scope.row.accountType-1]}}</template>
        </el-table-column>
        <el-table-column property="customerCode" width="150"  :formatter="emptyFn"   label="提现用户"></el-table-column>
        <el-table-column property="drawalStatus" label="提现状态">
          <template scope="scope">{{[ "已提现", "提现中", "提现失败"][scope.row.drawalStatus]}}</template>
        </el-table-column>
        <el-table-column property="drawalMoney"  width="120"  :formatter="emptyFn"   label="提现金额"></el-table-column>
         <el-table-column property="cardholder"  width="120"  :formatter="emptyFn"   label="银行户名"></el-table-column>
         <el-table-column property="bankAccount"  width="200"  :formatter="emptyFn"   label="银行卡号"></el-table-column>
         <el-table-column property="openingBank"  width="120"  :formatter="emptyFn"   label="开户行"></el-table-column>

        <el-table-column width="170" property="createTime" :formatter="dateTimeFormat" label="申请时间"></el-table-column>
        <el-table-column property="capitalSerialno"  width="200"  :formatter="emptyFn"   label="交易流水"></el-table-column>
        <el-table-column width="170" property="capitalTranstime" :formatter="dateTimeFormat" label="提现时间"></el-table-column>

          <el-table-column property="publishPricingMethod" width="120" label="是否自动提现">
            <template scope="scope">{{[ "是", "否",][scope.row.isAutoWithdraw-1]}}</template>
          </el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 提现 -->
    <el-dialog  title="提现"  :visible.sync="tixianMark" width="600px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="tixianFrom" ref="tixianFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
          <el-form-item label="交易流水:"  prop="capitalSerialno" >
            <el-input  placeholder=""    maxlength="30" style="width:208px"  v-model="tixianFrom.capitalSerialno"  ></el-input>
          </el-form-item>
          <el-form-item label="提现时间:"  prop="capitalTranstime" >
             <el-date-picker
              v-model="tixianFrom.capitalTranstime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
                placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <div>
            <el-form-item label="交易凭证:"  prop="zxTansferNo" class="is-required" >
              <uploadImg :img='img' v-if="imgFlag" @remove ='handleRemove'  @change ='imgPreview'></uploadImg>
            </el-form-item>
          </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tixianMark = false">取消</el-button>
        <el-button type="primary" @click="TXsave()">确定</el-button>
      </span>
   </el-dialog>
   <!-- 查看凭证弹窗 -->
    <div>
      <el-dialog title="查看凭证" :visible.sync="imgMark" :close-on-click-modal="false" width="40%" center  custom-class="el-dialog--center">
        <div class="block">
          <span class="demonstration"></span>
          <el-image :src="src"></el-image>
        </div>
        <!-- ----------------------------------------------------------------------------------运单 -->
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button type="primary" @click="imgMark=false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import uploadImg from '@/components/uploadImg.vue'
import DonMessage from '@/utils/message'
import { bPayDictionaryUploadFile, tWithdrawalInfoUpdate } from '@/api/common-signature'
import {
  offlineList // 列表
} from '@/api/consignment'
export default {
  components: {
    uploadImg
  },
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: 'false',
      total: 0,
      // 提现
      tixianMark: false,
      tixianFrom: {},
      img: [],
      imgList: [],
      imgFlag: false,
      imgMark: false, // 凭证
      src: '',
      rules: {
        capitalSerialno: { required: true, message: '请输入交易流水', trigger: 'blur' },
        capitalTranstime: { required: true, message: '请选择提现时间', trigger: 'blur' }
      },
      btnFlg: [],
      btnIdArr: ['00JP00HB001', '00JP00HB002', '00JP00HB003']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/platformEnd/withdrawal')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 凭证
    pingZheng (row) {
      this.imgMark = true
      this.loading = false
      this.src = row.drawalVoucher
    },
    // 提现
    tixianFn (row) {
      this.tixianMark = true
      this.tixianFrom.id = row.id
      this.imgFlag = true
    },
    TXsave () {
      this.$refs.tixianFrom.validate((valid) => {
        if (valid) {
          if (this.imgList.length == 0) {
            this.$alert('请上传交易凭证', '系统提示')
          } else {
            let imgfile = new FormData()
            imgfile.append('uploadFile', this.imgList[0].raw)
            imgfile.append('params', JSON.stringify())
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            bPayDictionaryUploadFile(imgfile).then((res) => {
              this.tixianFrom.drawalVoucher = res
              // 上传图片成功后 - 调用确认提现接口
              tWithdrawalInfoUpdate(this.tixianFrom).then((res) => {
                DonMessage.success('操作成功!')
                this.tixianMark = false
                this.imgList = []
                loading.close()
                this.getList(this.searchFrom)
              }).catch((err) => {
                this.loading1 = false
                DonMessage.error(err.message)
              })
            }).catch((err) => {
              DonMessage.error(err.message)
            })
          }
        }
      })
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    imgPreview (data) {
      this.imgList[0] = data[0]
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      offlineList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.tixianFrom = {}
      this.imgList = []
      this.img = []
      this.imgFlag = false
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
</style>
